// ADR 30.9.26ai §9/§11 — the learner's chosen install per slot, in
// `localStorage` under `lingara.apps.slot.<slot>`, every access guarded (a
// private window or a full quota reads as "no choice", never a throw).
//
// A stored choice is an install id, which is account data, and the key is not
// per-user, so every sign-out removes all of them (`clearSlotChoices`).

import type { AppSlot } from '../../wasm'

const PREFIX = 'lingara.apps.slot.'

export function readSlotChoice(slot: AppSlot): string | null {
  try {
    return window.localStorage.getItem(PREFIX + slot)
  } catch {
    return null
  }
}

export function writeSlotChoice(slot: AppSlot, installId: string): void {
  try {
    window.localStorage.setItem(PREFIX + slot, installId)
  } catch {
    // Unwritable storage: the choice lasts this render only.
  }
}

function choiceKeys(): string[] {
  const keys: string[] = []
  for (let i = 0; i < window.localStorage.length; i += 1) {
    const key = window.localStorage.key(i)
    if (key !== null && key.startsWith(PREFIX)) keys.push(key)
  }
  return keys
}

/** §6 — an uninstalled app stops being any slot's choice. */
export function forgetSlotChoice(installId: string): void {
  try {
    for (const key of choiceKeys()) {
      if (window.localStorage.getItem(key) === installId) window.localStorage.removeItem(key)
    }
  } catch {
    // Nothing stored that can be read, so nothing to forget.
  }
}

/** §11 — every `lingara.apps.slot.*` key, on sign-out. */
export function clearSlotChoices(): void {
  try {
    for (const key of choiceKeys()) window.localStorage.removeItem(key)
  } catch {
    // As above.
  }
}
